import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { compose } from 'redux';
import { Container, Dimmer, Grid, Loader, Portal, Button, Icon } from 'semantic-ui-react';
import _ from 'lodash';

// Constants and utils
import { ACL, ROUTES } from '../../shared/constants';

// Components
import ImpresaDocuments from '../../components/ProcessoImpresa/ImpresaDocuments';
import ImpresaForm from '../../components/ProcessoImpresa/ImpresaForm';
import ImpresaIntestatario from '../../components/ProcessoImpresa/ImpresaIntestatario';
import ImpresaGarante from '../../components/ProcessoImpresa/ImpresaGarante';
import ImpresaStatesStep from '../../components/ProcessoImpresa/ImpresaStateStep';
import ControlloSeniorManagerImpreseButton from '../../components/ProcessoImpresa/ControlloSeniorManagerImpreseButton';
import Infobox from '../../components/ProcessoImpresa/Infobox';
import ProvvigioniImpresa from '../../components/ProcessoImpresa/ProvvigioniImpresa';

// Services
import ImpresaService from '../../shared/services/api/impresa';
import GestioneProcessoImprese from '../../shared/services/rpc/gestione-processo-imprese';
import aclService from 'shared/lib/acl';

const StyledContainer = styled.div`
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 5px;
  padding: 20px 10px;
`;

const rightColumnStyle = {
  position: 'fixed',
  zIndex: 999,
  right: -18,
  top: 149,
  width: '35%',
  bottom: 0,
  overflowY: 'scroll',
  paddingRight: 32,
};

export class ProcessoImpresaDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false, // Manage loading of form
      impresaId: props.match.params.id, // Id of recesso tutor
      impresa: null, // Impresa entity
      isCreatingImpresa: false, // Manage loader on Impresa Intestatario
      impresaState: 'aperta',
    };
  }

  componentDidMount() {
    this.loadImpresaData();
  }

  loadImpresaData = () => {
    const { impresaId } = this.state;

    if (impresaId === 'new') {
      this.setState({ impresaState: 'aperta' });
      return;
    }

    this.setState({ isLoading: true });

    // Api call for get the impresa data if it's not new
    ImpresaService.get(impresaId)
      .then((response) => {
        this.setState({
          impresa: response,
          impresaState: response.stato,
          senior: response.senior,
        });
      })
      // API call returned an error
      .catch(() => {
        // Notify the error
        this.props.notification().addNotification({
          message: 'Impossibile caricare il dettaglio, impresa non trovata',
          level: 'error',
        });

        // Redirect to Recessi list
        this.props.history.push(ROUTES.PROCESSO_IMPRESE);
      })
      .finally(() => this.setState({ isLoading: false }));
  };

  /** Function called on create new processo impres */
  createImpresa = (anagraficaId, agenziaId, collaboratoreId) => {
    this.setState({ isCreatingImpresa: true });
    const data = {
      collaboratore: collaboratoreId,
      intestatario: anagraficaId,
      agenziaKiron: agenziaId,
    };

    return ImpresaService.create(data)
      .then((response) => {
        this.setState({ isCreatingImpresa: false, impresaId: response.id });
        this.props.notification().addNotification({
          message: 'Pratica creata con successo',
          level: 'success',
        });
        this.props.history.push(`${ROUTES.PROCESSO_IMPRESE}/${response.id}`);
        this.loadImpresaData();
      })
      .catch((error) => {
        this.setState({ isCreatingImpresa: false });

        // A volte l'oggetto error di Axios contiene i dati direttamente se la struttura è leggermente diversa
        const responseDetail = _.get(error, 'response.data.detail') ||
                               _.get(error, 'response.detail') ||
                               _.get(error, 'data.detail') ||
                               _.get(error, 'detail');

        const errorMessage = responseDetail ? responseDetail : 'Errore durante la creazione del processo impresa';

        this.props.notification().addNotification({
          message: errorMessage,
          level: 'error',
        });
        throw error;
      });
  };

  setSatoToChiusa = () => {
    this.setState({ isLoading: true });
    ImpresaService.setToChiusa(this.state.impresaId)
      .then(() => {
        // Show notification
        this.props.notification().addNotification({
          message: 'Stato aggiornato correttamente',
          level: 'success',
        });
        this.loadImpresaData();
      })
      .catch((error) => {
        // Show notification
        this.props.notification().addNotification({
          message:
            _.get(error, 'data.detail') && _.get(error, 'data.detail') !== 'Validazione fallita'
              ? error.data.detail
              : 'Si è verificato un problema nel passaggio di stato',
          level: 'error',
        });
      })
      .finally(() => this.setState({ isLoading: false }));
  };

  setSbloccoGenerazioneContratto = (sbloccoValue) => {
    this.setState({ isLoading: true });
    if (sbloccoValue === true) {
      GestioneProcessoImprese.setSbloccoGenerazioneContratto(this.state.impresaId)
        .then(() => {
          // Show notification
          this.props.notification().addNotification({
            message: 'Generazione contratto sbloccata correttamente',
            level: 'success',
          });
          this.loadImpresaData();
        })
        .catch((error) => {
          // Show notification
          this.props.notification().addNotification({
            message:
              _.get(error, 'data.detail') && _.get(error, 'data.detail') !== 'Validazione fallita'
                ? error.data.detail
                : 'Si è verificato un problema nello sblocco della generazione del contratto',
            level: 'error',
          });
        })
        .finally(() => this.setState({ isLoading: false }));
    } else if (sbloccoValue === false) {
      GestioneProcessoImprese.annullaSbloccoGenerazioneContratto(this.state.impresaId)
        .then(() => {
          // Show notification
          this.props.notification().addNotification({
            message: 'Generazione contratto bloccata correttamente',
            level: 'success',
          });
          this.loadImpresaData();
        })
        .catch((error) => {
          // Show notification
          this.props.notification().addNotification({
            message:
              _.get(error, 'data.detail') && _.get(error, 'data.detail') !== 'Validazione fallita'
                ? error.data.detail
                : 'Si è verificato un problema nel blocco della generazione del contratto',
            level: 'error',
          });
        })
        .finally(() => this.setState({ isLoading: false }));
    }
  };

  showControlloSeniorOptions = () => {
    const { impresa, impresaState } = this.state;
    const { auth } = this.props;

    if (!impresa) {
      return false;
    }

    // If user is admin, responsabileControlli or productManagerImprese check only state and type of pratica
    if (aclService.check(auth, ['admin', 'responsabileControlli', 'productManagerImprese'])) {
      return impresa.id && impresaState === 'aperta';
    }

    // If user is senior check state, type, gestore and senior of pratica
    if (aclService.check(auth, ['senior'])) {
      return impresa.id && impresaState === 'aperta' && impresa.collaboratore !== impresa.senior;
    }

    return false;
  };

  render() {
    const { isLoading, impresaId, impresa, impresaState } = this.state;
    const { history, notification, auth } = this.props;

    return (
      <Dimmer.Dimmable dimmed={isLoading}>
        <Helmet>
          <title>Processo Impresa</title>
          <meta name="description" content="Processo Impresa" />
        </Helmet>

        <Grid>
          <ImpresaStatesStep state={impresaState} />

          <Grid.Column width={10} key="main">
            <Container style={{ width: '100%' }}>
              <StyledContainer>
                <ImpresaIntestatario
                  createImpresa={this.createImpresa}
                  impresa={impresa}
                  isNew={impresaId === 'new'}
                  notification={notification}
                  auth={auth}
                  isCreatingImpresa={this.state.isCreatingImpresa}
                  onRefresh={this.loadImpresaData}
                />

                {impresaId !== 'new' && (
                  <div>
                    <ImpresaGarante
                      impresa={impresa}
                      notification={notification}
                      auth={auth}
                      onRefresh={this.loadImpresaData}
                      isGarantePresente={impresa && !_.isEmpty(impresa.garante) ? true : false}
                    />
                    <ImpresaForm
                      {...{ impresaId, impresa, notification, history, auth }}
                      anagraficaName={impresa ? impresa.intestatario.nominativo : null}
                      updateImpresa={() => {}}
                    />
                  </div>
                )}
              </StyledContainer>
            </Container>
          </Grid.Column>

          <Grid.Column width={10} key="right-sidebar">
            <Portal open>
              <Grid>
                <Grid.Column style={rightColumnStyle}>
                  {impresa && impresa.stato === 'aperta' && (
                    <div style={{ marginBottom: '15px' }}>
                      <Button primary icon labelPosition="left" type="button" onClick={() => this.setSatoToChiusa()}>
                        <Icon name="angle double right" />
                        Aggiorna stato in conclusa
                      </Button>
                    </div>
                  )}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '15px' }}>
                    {aclService.check(this.props.auth, ACL.CAN_SBLOCCO_IMPRESE) &&
                      impresa &&
                      impresa.sbloccoGenerazioneContratto !== true &&
                      impresa.stato === 'aperta' && (
                        <div style={{ marginBottom: '15px' }}>
                          <Button
                            color="red"
                            icon
                            labelPosition="left"
                            type="button"
                            onClick={() => this.setSbloccoGenerazioneContratto(true)}
                          >
                            <Icon name="lock" />
                            Sblocca generazione contratto
                          </Button>
                        </div>
                      )}
                    {aclService.check(this.props.auth, ACL.CAN_SBLOCCO_IMPRESE) &&
                      impresa &&
                      impresa.sbloccoGenerazioneContratto === true &&
                      impresa.stato === 'aperta' && (
                        <Button
                          color="green"
                          icon
                          labelPosition="left"
                          type="button"
                          onClick={() => this.setSbloccoGenerazioneContratto(false)}
                        >
                          <Icon name="unlock" />
                          Generazione contratto sbloccata
                        </Button>
                      )}
                    {impresa && this.showControlloSeniorOptions() && impresa.stato === 'aperta' && (
                      <ControlloSeniorManagerImpreseButton processoImprese={impresa} notification={notification} />
                    )}
                  </div>
                  <Infobox processoImprese={impresa} />
                  {impresa && <ProvvigioniImpresa processoImpreseId={impresaId} userAcl={auth} />}
                  <ImpresaDocuments
                    isNew={impresaId === 'new'}
                    impresaId={impresaId}
                    notification={notification}
                    anagraficaName={impresa ? impresa.intestatario.nominativo : null}
                    anagraficaId={impresa ? impresa.intestatario.id : null}
                    stato={impresa ? impresa.stato : null}
                    sbloccoGenerazioneContratto={impresa ? impresa.sbloccoGenerazioneContratto : null}
                  />
                </Grid.Column>
              </Grid>
            </Portal>
          </Grid.Column>
        </Grid>

        <Dimmer active={isLoading} inverted>
          <Loader />
        </Dimmer>
      </Dimmer.Dimmable>
    );
  }
}

ProcessoImpresaDetails.propTypes = {
  /** Used for manage history of the browser -> redirect */
  history: PropTypes.object,
  /** Containes information about the URL -> used for get the cadidato ID  */
  match: PropTypes.object,
  /** Function for call the notification system */
  notification: PropTypes.func,
  /** Object with data of logged user */
  auth: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(null, mapDispatchToProps);

export default compose(withConnect)(ProcessoImpresaDetails);



// WEBPACK FOOTER //
// ./app/containers/ProcessoImpresaDetails/index.js